var _defs, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconOnlineLearningOnlineCourse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.955 5.776s.494-1.529 4.717-1.687a.654.654 0 0 1 .713.595v6.273a.651.651 0 0 1-.679.588c-4.251.151-4.751 1.688-4.751 1.688V5.776m0 0s-.493-1.529-4.716-1.687a.654.654 0 0 0-.713.595v6.273a.651.651 0 0 0 .679.588c4.25.151 4.75 1.688 4.75 1.688V5.776"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75 16.25h22.5m-18.5 3.5h14.5m-11.5-1v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconOnlineLearningOnlineCourse2);
export default __webpack_public_path__ + "static/media/streamline-icon-online-learning-online-course-2.97416357.svg";
export { ForwardRef as ReactComponent };